<div class="filter-chip-group">
  <!-- Filter chips -->
  <umss-filter-chip
    *ngFor="let chip of chips"
    [text]="chip.text"
    [value]="chip.value"
    [removable]="chip.removable ?? true"
    [size]="size"
    [variant]="variant"
    (chipClick)="onChipClick($event)"
    (chipRemove)="onChipRemove($event)">
  </umss-filter-chip>

  <!-- Clear All button -->
  <button
    *ngIf="showClearAll && hasChips"
    type="button"
    class="clear-all-button"
    (click)="onClearAllClick()"
    [attr.aria-label]="clearAllText">
    {{ clearAllText }}
  </button>
</div>